import { styled } from '../theme';
import Text from './Text';

const H2 = styled(Text.withComponent('h2'))(({ theme }) => ({
    fontWeight: theme.typography.fontWeight.medium,
    fontSize: '2.6rem',
    margin: 0,
}));

export default H2;
